<template>
    <div class="load-mask-parent" style="overflow-x: auto;">
        <component-title
            :config="config">
        </component-title>
        <div :class="loadMask"></div>
        <RadarChart :labels="labels" :items="items" :legend="legend" :backgroundFill="backgroundFill"
                    :style="styles"
        ></RadarChart>
        <div class="chart-options">
            <label>
                <input type="checkbox" v-model="legend" v-on:click="toggleLegend"> {{ t('Show legend') }}
            </label>
            <label>
                <input type="checkbox" v-model="backgroundFill" v-on:click="togglebackgroundFill">
                {{ t('Show backgroundFill') }}
            </label>
        </div>
    </div>
</template>

<script>
import RadarChart from './RadarChart';
import ComponentTitle from "@/components/ComponentTitle.vue";
import ActionComponent from "./grid/ActionComponent";

export default {
    name: 'Radar',
    components: {ComponentTitle, RadarChart, ActionComponent},
    props: {
        config: {
            Type: Object
        },
        eventBus: {
            type: Object,
        },
        extraData: {
            Type: Object,
        },
        index: {
            Type: Number
        },
        moduleConfig: {
            Type: Object
        },
        routeName: {
            Type: String,
            require: true,
        },
    },
    computed: {
        gridId() {
            return this.config.index + '_' + this.index;
        },
        styles() {
            return {
                height: `800px`,
                position: 'relative'
            }
        }
    },
    data() {
        return {
            loadMask: '',
            internalLoadEvent: null,
            moduleIndex: null,
            events: [],
            state: {},
            legend: true,
            backgroundFill: true,

            items: [],
            labels: []
        };
    },

    beforeDestroy() {
        this.unmountEvents();
    },
    mounted() {
        this.$root.$once('CustomModule:ready', (customModuleEventName, moduleIndex) => {
            this.events.push('CustomModule:ready');
            this.events.push(customModuleEventName);
            this.moduleIndex = moduleIndex;
            this.$root.$on(customModuleEventName, (moduleConfig, state) => {
                this.mountEvents();
            });
        });
    },
    methods: {
        mountEvents() {
            let eventManagerService = this.$root.getEventManager();
            eventManagerService.bindEvents(this.defaultBindEvents(), this);
            this.bindLoadEvent();

            this.eventBus.$on(`${this.moduleIndex}-ToggleFilterPanel:filter-change`, (filterName, filterValue, filter, filters, serializedFilters) => {
                this.state = Object.assign(this.state, serializedFilters);
                this.loadMask = 'lmask';
                eventManagerService.emitEvents(this.internalLoadEvent, [{'state': this.state}]);
            });

            this.events.push(`${this.moduleIndex}-ToggleFilterPanel:filter-change`);
        },
        unmountEvents() {
            this.events.forEach(e => {
                this.eventBus.$off(e);
            });
        },
        getComponentIndex() {
            return `${this.config.index}`;
        },
        defaultBindEvents() {
            let componentIndex = this.getComponentIndex();

            let bindEvents = [{
                name: 'afterLoadEvent',
                componentIndex: componentIndex,
            }];

            if (this.config.bindEvents) {
                let configBindEvents = [];

                (this.config.bindEvents || []).forEach(e => {
                    configBindEvents.push(Object.assign({}, e));
                });
                bindEvents = bindEvents.concat(configBindEvents);
            }

            return bindEvents;
        },
        bindLoadEvent(callback) {
            if (null === this.internalLoadEvent) {
                this.internalLoadEvent = this.config.emitEvents['load'] || [];

                this.internalLoadEvent.push({
                    type: 'frontend',
                    config: {
                        eventName: `${this.config.index}:afterLoadEvent`,
                        callback: callback,
                        data: {
                            data: "1"
                        }
                    }
                });
            }
        },
        afterLoadEvent(config, data) {
            let d = data.data.data;

            let labelFieldName = '';
            let colorFieldName = '';
            let fields = [];
            this.labels = [];
            this.items = [];

            this.config.labels.forEach((value) => {
                if (value.type === 'label') {
                    labelFieldName = value.data;
                }

                if (value.type === 'color') {
                    colorFieldName = value.data;
                }

                if (value.type === 'data') {
                    this.labels.push(value.name);
                    fields.push(value.data);
                }
            });

            for (const [key, value] of Object.entries(d)) {
                let item = {'data': [], 'label': ''};

                if (colorFieldName in value) {
                    item['color'] = value[colorFieldName];
                }

                if (labelFieldName in value) {
                    item['label'] = value[labelFieldName];
                }

                fields.forEach((field) => {
                    if (field in value) {
                        item['data'].push(value[field]);
                    }
                });

                this.items.push(item);
            }

            this.loadMask = '';
        },
        toggleLegend() {
            this.legend = !this.legend;
        },
        togglebackgroundFill() {
            this.backgroundFill = !this.backgroundFill;
        },
    }
}
</script>



// WEBPACK FOOTER //
// ChartRadarComponent.vue?53c5cedd